export const health = "/assets/jpg/healthInsurance.jpg";
export const mail = "/assets/svg/mail.svg";
export const phone = "/assets/svg/phone.svg";
export const user = "/assets/svg/user.svg";
export const arrowRight = "/assets/svg/arrow-right.svg";